import { createApiSlice } from "@common";
import {
  CRUD_OPPORTUNITY,
  CRUD_OPPORTUNITY_ALERT,
  CRUD_OPPORTUNITY_BY_ID,
  CRUD_OPPORTUNITY_BY_OWNER,
} from "@routes";

const apiConfig = [
  {
    name: "addOpportunity",
    method: "post",
    url: CRUD_OPPORTUNITY,
    stateKey: "message",
  },
  {
    name: "getOpportunity",
    method: "get",
    url: CRUD_OPPORTUNITY,
    stateKey: "data",
  },
  {
    name: "getOpportunityByOwner",
    method: "get",
    url: CRUD_OPPORTUNITY_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateOpportunity",
    method: "put",
    url: CRUD_OPPORTUNITY,
    stateKey: "message",
  },
  {
    name: "deleteOpportunity",
    method: "delete",
    url: CRUD_OPPORTUNITY,
    stateKey: "message",
  },
  {
    name: "opportunityDeleteAlert",
    method: "get",
    url: CRUD_OPPORTUNITY_ALERT,
    stateKey: "opportunityAlertData",
  },
  {
    name: "getOpportunityDetailsById",
    method: "get",
    url: CRUD_OPPORTUNITY_BY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    opportunityAlertData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunity",
  apiConfig,
  customReducers,
);
const opportunitySlice = slice;

export default opportunitySlice.reducer;

export const {
  addOpportunity,
  getOpportunity,
  getOpportunityByOwner,
  updateOpportunity,
  deleteOpportunity,
  opportunityDeleteAlert,
  getOpportunityDetailsById,
} = thunks;

export const { rowSelect } = actions;
